import React from 'react';
import { ErrorHandlingMedia } from '../../common/ErrorHandlingMedia';

interface MediaDisplayProps {
  mediaUrl?: string;
  altText: string;
  type: 'image' | 'video';
  format?: string;
  variant?: string;
  objectFit?: 'cover' | 'contain';
  aspectRatio?: string;
  className?: string;
  controls?: boolean;
  autoPlayOnMount?: boolean;
  autoPlayOnHover?: boolean;
  muted?: boolean;
  fullSize?: boolean; // when false, do not force w-full h-full
  loop?: boolean;
}

export const MediaDisplay: React.FC<MediaDisplayProps> = ({
  mediaUrl,
  altText,
  type,
  objectFit = 'cover',
  aspectRatio,
  className = '',
  controls,
  autoPlayOnMount = false,
  autoPlayOnHover = false,
  muted = true,
  fullSize = true,
  loop = false
}) => {
  if (!mediaUrl) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 w-full h-full ${className}`}>
        <span className="text-gray-400 text-xs">No media</span>
      </div>
    );
  }

  const isBlob = mediaUrl.startsWith('blob:');
  const isPdf = /\.pdf(\?|#|$)/i.test(mediaUrl);
  // For previews, convert blob URL to a safe object URL usage inside <img>/<video> is fine,
  // but some browsers block blob in nested components. Here we keep blob but add fallback UI.
  const style = {
    objectFit,
    aspectRatio
  } as React.CSSProperties;

  if (isPdf) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 text-gray-500 text-xs ${className}`} style={style}>
        PDF
      </div>
    );
  }

  return (
    <ErrorHandlingMedia
      src={mediaUrl}
      alt={altText}
      type={type}
      className={`${fullSize ? 'w-full h-full' : ''} ${className}`.trim()}
      style={style}
      controls={controls ?? (type === 'video')}
      autoPlayOnMount={autoPlayOnMount}
      autoPlayOnHover={autoPlayOnHover}
      muted={muted}
      loop={loop}
    />
  );
};